import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerDirective, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { ModuloPermissoesService } from 'src/app/api/module/erp/services/area-logada/modulo-permissoes/modulo-permissoes.service';
import { MotivoRecusaPortabilidadeService } from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/motivos-recusa.service';
import { PropostaCotacaoService } from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import { Modulo } from 'src/app/api/module/erp/shared/enumerable/modulos';
import { PropostaExternaEnum } from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import { SubModuloNome } from 'src/app/api/module/erp/shared/enumerable/submodulos';
import {
  TipoPropostaEnum,
  TipoPropostaEnumDescription,
} from 'src/app/api/module/erp/shared/enumerable/tipo-poposta.enum';
import { TipoProduto_E_OperadoraComponent } from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import { AtualizacaoForcadaService } from 'src/app/api/module/erp/shared/services/atualizacao-forcada-service.service';
import { CompartilharDadosEntreComponentsService } from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import { ErrorLoggingService } from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import { ExecucaoSeguraService } from 'src/app/api/module/erp/shared/services/execucao-segura.service';
import { SpinnerService } from 'src/app/api/module/erp/shared/services/spinner-service.service';
import { BeneficiarioPropostaSerice } from 'src/app/api/module/externo/services/proposta/beneficiario.proposta.service';
import { VerificaEmail } from 'src/app/components/helper/form-validators/verifica-email';
import { VerificaNome } from 'src/app/components/helper/form-validators/verifica-nome';
import { ScrollService } from 'src/app/components/helper/service/scroll/scroll.service';
import { EnderecoComponent } from 'src/app/pages/area-logada/shared/components/endereco/endereco.component';
import { CustomValidators } from 'src/app/pages/area-logada/shared/validators/custom-validators';
import { PropostaEntidadeDependenteComponent } from '../../proposta-entidade-dependente/proposta-entidade-dependente.component';

@Component({
  selector: 'app-proposta-beneficiario-colaborador',
  templateUrl: './proposta-beneficiario-colaborador.component.html',
  styleUrls: ['./proposta-beneficiario-colaborador.component.scss'],
  // standalone: true,
  // imports: [CommonModule],
})
export class PropostaBeneficiarioColaboradorComponent implements OnInit, OnChanges {
  @ViewChild(PropostaEntidadeDependenteComponent)
  _dependenteComponentViewChild!: PropostaEntidadeDependenteComponent;
  @ViewChild('modalPortabilidade')
  modalPortabilidadeTemplate!: TemplateRef<any>;
  @ViewChild('modalVigenciaPrevista') modalVigenciaPrevistaTemplate!: TemplateRef<any>;
  @ViewChild('modalSumulaRecusaTemplate') modalSumulaRecusaTemplate!: TemplateRef<any>;
  @ViewChild('datepicker', {static: false}) datepicker?: BsDatepickerDirective;
  @ViewChild(EnderecoComponent) enderecoComponent: EnderecoComponent;

  @Input() listaEnumTipoProposta: any;
  @Input() listaEstatusCivil: any;
  @Input() _listaGeneros: any;
  @Input() listaProfissao: any;
  @Input() entidadeId: any;
  @Input() ehColaborador!: boolean;
  @Input() somenteLeituraStep: boolean = false;
  dadosRecebidosDoBeneciarioVM: any;
  proposalId: string = '';
  mostrarBotaoEnviarOperadora: boolean = false;

  mostrarBotaoPortabilidade: boolean = false;
  listaDeBeneficiarios = new Array<any>();

  //beneficiários
  formBeneficiario!: FormGroup;
  isOtherGender: boolean = false;
  isOtherProfession: boolean = false;
  listaDependentes = new Array<any>();
  titularDaProposta: string = '';
  isFormSubmited: boolean = false;
  errorMessageDadosTitular: boolean = false;
  formTouched: boolean = false;
  ehReducaoCarencia: boolean = false;
  //banco
  formGrupDadosBancarios!: FormGroup;
  mostrarMensagemErroBanco: boolean = false;
  bancoConveniado: boolean = true;
  dadosBancariosTitular: any;
  modalRef?: BsModalRef;
  modalRefConfirmacao?: BsModalRef;
  modalRefSumulaRecusa?: BsModalRef;
  listaDeBancosConveniados = new Array<any>();
  listaDeBancosNaoConveniados = new Array<any>();
  listaBancos = new Array<any>();
  //portabilidade
  formPortabilidade!: FormGroup;
  listaRecusaPortabilidadeEnviar = new Array<any>();
  menssagemErroCampoData: string = '';
  bsConfigVigencia: Partial<BsDatepickerConfig>;
  minDate!: Date;
  objPortabilidade = new Array<any>();
  modalPortabilidade: boolean = false;
  listaBeneficiariosAguardandoPortabilidade: any[] = [];
  listaBeneficiariosAguardandoPortabilidadeOrdenada: any[] = [];
  aceiteOuRecusaPortabilidade: boolean | undefined = undefined;
  opcoesRecusa: any[] = [];
  titularRecusouPortabilidade: boolean = false;
  propostaEnum = PropostaExternaEnum;
  heOdonto: boolean = false;
  outrosValores = ['outro', 'outros', 'outra', 'outras', 'Outro (Especifique:)'];
  ehInclusaoDependente: boolean = false;
  stepAtual: any;
  isBeneficiary: boolean = false;
  mostrarModalVigenciaPrevista: boolean = false;
  formProposta: FormGroup;
  dataVigenciaPrevistaManual: any;
  requiresManualEffectiveDate;
  textoModalVigenciaManual: string = '';
  listabeneficiariosComSumula21: any[];
  _tipoPropostaEnum = TipoPropostaEnum;
  propostaStepEnum = PropostaExternaEnum;

  constructor(
    private formBuilder: FormBuilder,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private _spinnerService: SpinnerService,
    private _scrollService: ScrollService,
    private _propostaCotacaoService: PropostaCotacaoService,
    private bsLocaleService: BsLocaleService,
    private _errorLogging: ErrorLoggingService,
    private _motivoRecusaPortabilidadeService: MotivoRecusaPortabilidadeService,
    private execucaoSegura: ExecucaoSeguraService,
    private _atualizacaoForcadaService: AtualizacaoForcadaService,
    private cdr: ChangeDetectorRef,
    private moduloPermissoesService: ModuloPermissoesService,
    private _beneficiarioProposaService: BeneficiarioPropostaSerice,
  ) {
    this.bsLocaleService.use('pt-br');
    this.bsConfigVigencia = {
      isAnimated: true,
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
      minDate: new Date(1900, 0, 1),
    };
  }

  ngOnInit(): void {
    this.receberDadosDoBeneficiario();
    this.criarFormBeneficario();
    this.criarFormDadosBancarios();
    this.criarFormularioPortabilidade();
    this.criarFormularioProposta();
    this.somenteLeitura();
    this.buscarOpcoesRecusaPortabilidade();
    this.atualizacaoForcacao();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  atualizacaoForcacao() {
    this._atualizacaoForcadaService.atualizacaoForcadaPropostaBeneficiarioColaboradorSubject$.subscribe(() => {
      this.goToTop();
      this.mostrarBotaoEnviarOperadora = true;
    });
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  somenteLeitura() {
    this.formBeneficiario.controls['birthDate'].disable();
    this.formBeneficiario.controls['professionId'].disable();
    this.formBeneficiario.controls['otherProfession'].disable();
    this.formBeneficiario.controls['proposalType'].disable();
    this.formBeneficiario.controls['sex'].disable();
    this.formBeneficiario.controls['analysisPeriodReductionCheck'].disable();
  }

  async receberDadosDoBeneficiario(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        async data => {
          try {
            if (!data || !Array.isArray(data) || data.length === 0 || !data[0]) {
              this.dadosRecebidosDoBeneciarioVM = [];
              resolve(null);
              return;
            }
            this.dadosRecebidosDoBeneciarioVM = data;
            const dadosBeneficiario = data[0]?.dadosBeneficiario;
            this.stepAtual = dadosBeneficiario?.step;
            this.mostrarModalVigenciaPrevista = dadosBeneficiario.requiresManualEffectiveDate || null;

            this.ehInclusaoDependente = dadosBeneficiario.dependentInclusion ? true : false;

            // Verifica se existem dados do beneficiário antes de continuar
            if (!dadosBeneficiario) {
              resolve(null);
              return;
            }
            // Atualiza o ID da proposta primeiro
            this.proposalId = dadosBeneficiario.id || '';

            // 1. Primeiro processa os dados básicos do beneficiário
            if (dadosBeneficiario.holderProposal) {
              await this.execucaoSegura
                .executar(() => this.separarBeneficiarios(dadosBeneficiario))
                .catch(error =>
                  this.erroSentry(
                    'Erro ao separar beneficiários',
                    error,
                    'Erro ao processar dados do beneficiário',
                    dadosBeneficiario,
                  ),
                );

              // 2. Processa o endereço se existir
              if (dadosBeneficiario.holderProposal?.addressData) {
                const {addressData} = dadosBeneficiario.holderProposal;
                // Preenche dados de endereço
                await this.execucaoSegura
                  .executar(() => this.preencherDadosEndereco(addressData))
                  .catch(error =>
                    this.erroSentry(
                      'Erro ao preencher endereço',
                      error,
                      'Falha ao preencher dados de endereço',
                      addressData,
                    ),
                  );
              }
              // 3. Preenche dados do titular
              await this.execucaoSegura
                .executar(() => this.preencherDadosTitular(dadosBeneficiario))
                .catch(error =>
                  this.erroSentry(
                    'Erro ao preencher dados do titular',
                    error,
                    'Falha ao preencher dados do titular',
                    dadosBeneficiario,
                  ),
                );
            }

            // 4. Processa os dados bancários se existirem
            const dadosBancarios = data[0]?.dadosBancarios;
            if (dadosBancarios) {
              this.dadosBancariosTitular = dadosBancarios;
              this.listaDeBancosConveniados = dadosBancarios.bancosConveniados || [];
              this.listaBancos = dadosBancarios.listaBancosCompleta || [];

              if (dadosBancarios.dadosBancariosTitular) {
                await this.execucaoSegura
                  .executar(() => this.preencherDadosBancarios(dadosBancarios.dadosBancariosTitular))
                  .catch(error =>
                    this.erroSentry(
                      'Erro ao preencher dados bancários',
                      error,
                      'Falha ao processar dados bancários do titular',
                      dadosBancarios.dadosBancariosTitular,
                    ),
                  );
              }
            }

            // 5. Verifica se é o passo 24 (pagamento confirmado)
            if (dadosBeneficiario.step === PropostaExternaEnum.PAGAMENTO_CONFIRMADO) {
              this.mostrarBotaoEnviarOperadora = true;
              // this.somenteLeituraStep = true;
              // this.dexarFormSomenteLeitura(this.somenteLeituraStep);
            }

            // 6. Verifica portabilidade
            await this.execucaoSegura
              .executar(() => this.verificaPortabilidade())
              .catch(error =>
                this.erroSentry(
                  'Erro ao verificar portabilidade',
                  error,
                  'Falha ao verificar situação de portabilidade',
                  {},
                ),
              );

            resolve(true);
          } catch (error) {
            reject(error);
          }
        },
        error => {
          reject(error);
        },
      );
    });
  }

  separarBeneficiarios(dados: any) {
    const beneficiario = dados && dados.holderProposal;

    if (beneficiario) {
      const dadosTitular = {...beneficiario};
      delete dadosTitular.dependentsProposal;

      this.listaDeBeneficiarios.push({
        ...dadosTitular,
        isDependent: false,
        proposalType: dados.proposalType,
      });

      if (beneficiario.dependentsProposal && Array.isArray(beneficiario.dependentsProposal)) {
        beneficiario.dependentsProposal.forEach((dependente: any) => {
          const itemDependente = {
            ...dependente,
            isDependent: true,
          };
          this.listaDeBeneficiarios.push(itemDependente);
        });
      }

      this.separarBeneficiarioSumula21();
    }
  }

  verificaPortabilidade() {
    const temPortabilidade = this.listaDeBeneficiarios.some(
      tipoDeProposta => tipoDeProposta.proposalType === TipoPropostaEnum.PORTABILIDADE,
    );

    //step 22 - inicia portabilidade se houver()
    if (
      (this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario.step == PropostaExternaEnum.RETORNO_OPERADORA ||
        this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario.step ==
          PropostaExternaEnum.RETORNO_OPERADORA_DEPENDENTES) &&
      temPortabilidade
    ) {
      this.mostrarBotaoPortabilidade = true;
      if (this.podeExibirBotaoEnviarPortabilidade) this.abrirModalPortabilidadeAutomaticamente();
    }
  }

  marcarCamposComoTouched(form: FormGroup) {
    this.isFormSubmited = true;
    Object.keys(form.controls).forEach(campo => {
      const controle = form.get(campo);
      controle?.markAsTouched();
      controle?.updateValueAndValidity();
    });
  }

  onFieldChange() {
    if (this.formTouched) {
      this.condionalDeObrigatoriedadeContatos();
      this.errorMessageDadosTitular = !this.isFormValidDadosTitular();
      this.mostrarMensagemErroBanco = !this.isFormValidDadosBancarios();
    }
  }

  goToTop() {
    this._scrollService.scrollToElement('propostaExterna', 140);
    this._scrollService.setStyle('propostaExterna', {
      'margin-top': '-141px !important',
    });
  }

  //Beneficiário
  criarFormBeneficario() {
    this.formBeneficiario = this.formBuilder.group({
      name: new FormControl('', [Validators.required, Validators.minLength(2), Validators.maxLength(250)]),
      id: new FormControl(''),
      birthDate: new FormControl('', [Validators.required]),
      cpf: new FormControl('', [Validators.required, CustomValidators.validaCPF, Validators.maxLength(11)]),
      professionId: new FormControl(null, [Validators.required]),
      otherProfession: new FormControl(''),
      sex: new FormControl(1, [Validators.required]),
      gender: new FormControl(null),
      otherGender: new FormControl(''),
      civilStatusId: new FormControl(null, [Validators.required]),
      mobilePhone: new FormControl(''),
      homePhone: new FormControl(''),
      businessPhone: new FormControl(''),
      email: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.minLength(2),
        Validators.maxLength(250),
        VerificaEmail,
      ]),
      mothersName: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(250),
        VerificaNome,
      ]),
      cns: new FormControl('', [Validators.required, Validators.maxLength(17)]),
      previousOperator: new FormControl(''),
      stateId: new FormControl(null),
      cityId: new FormControl(''),
      analysisPeriodReductionCheck: new FormControl(false, [Validators.required]),
      proposalType: new FormControl(null),
      dwellTime: new FormControl(null),
      // fileDAPO: new FormControl(''),
      // fileCTP: new FormControl(''),
      beneficiaryAdress: new FormControl({}),
      dependents: new FormControl({}),
      analysisPeriodReduction: new FormControl({}),
      idProfissao: new FormControl({}),
    });
  }

  condionalDeObrigatoriedadeContatos(): boolean {
    const email = this.formBeneficiario.controls['email'].value;
    const businessPhone = this.formBeneficiario.controls['businessPhone'].value;
    const homePhone = this.formBeneficiario.controls['homePhone'].value;
    const mobilePhone = this.formBeneficiario.controls['mobilePhone'].value;

    if (!email && !mobilePhone && !businessPhone && !homePhone) {
      this.formBeneficiario
        .get('email')
        ?.setValidators([
          Validators.required,
          Validators.email,
          Validators.minLength(2),
          Validators.maxLength(250),
          VerificaEmail,
        ]);

      this.formBeneficiario.get('mobilePhone')?.setValidators([Validators.required]);
      this.formBeneficiario.get('businessPhone')?.setValidators([Validators.required]);
      this.formBeneficiario.get('homePhone')?.setValidators([Validators.required]);

      this.formBeneficiario.get('email')?.updateValueAndValidity();
      this.formBeneficiario.get('mobilePhone')?.updateValueAndValidity();
      this.formBeneficiario.get('businessPhone')?.updateValueAndValidity();
      this.formBeneficiario.get('homePhone')?.updateValueAndValidity();

      return true;
    } else {
      this.formBeneficiario.get('email')?.clearValidators();
      this.formBeneficiario.get('mobilePhone')?.clearValidators();
      this.formBeneficiario.get('businessPhone')?.clearValidators();
      this.formBeneficiario.get('homePhone')?.clearValidators();

      if (email) {
        this.formBeneficiario
          .get('email')
          ?.setValidators([Validators.email, Validators.minLength(2), Validators.maxLength(250), VerificaEmail]);
      }

      if (mobilePhone) {
        this.formBeneficiario.get('mobilePhone')?.setValidators([]);
      }

      if (businessPhone) {
        this.formBeneficiario.get('businessPhone')?.setValidators([]);
      }

      if (homePhone) {
        this.formBeneficiario.get('homePhone')?.setValidators([]);
      }

      this.formBeneficiario.get('email')?.updateValueAndValidity();
      this.formBeneficiario.get('mobilePhone')?.updateValueAndValidity();
      this.formBeneficiario.get('businessPhone')?.updateValueAndValidity();
      this.formBeneficiario.get('homePhone')?.updateValueAndValidity();

      return false;
    }
  }

  inserirValidadoresAntigaOperadora(mostrarFormulario: boolean) {
    this.ehReducaoCarencia = mostrarFormulario;

    const camposParaValidar = ['previousOperator', 'dwellTime', 'stateId', 'cityId'];

    camposParaValidar.forEach(campo => {
      const control = this.formBeneficiario.get(campo);

      if (mostrarFormulario) {
        control?.setValidators([Validators.required]);

        control?.markAsTouched({onlySelf: true});
        control?.markAsDirty({onlySelf: true});
        control?.updateValueAndValidity({onlySelf: true, emitEvent: false});
        if (!control?.value) {
          control?.setErrors({required: true}, {emitEvent: false});
        }
      } else {
        control?.clearValidators();
        control?.setErrors(null, {emitEvent: false});
        control?.markAsUntouched({onlySelf: true});
        control?.markAsPristine({onlySelf: true});
        control?.reset('', {emitEvent: false});
      }

      control?.updateValueAndValidity({onlySelf: true});
    });

    this.cdr.detectChanges();
  }

  onChangeProfession(profissaoId: any) {
    const profissaoSelecionada = this.listaProfissao.find(p => p.id === profissaoId);
    if (profissaoSelecionada) {
      const nome = profissaoSelecionada.name;
      this.isOtherProfession = this.outrosValores.includes(nome.toLowerCase());
    }

    if (!this.isOtherProfession) {
      this.formBeneficiario.controls['otherProfession'].reset();
    }
  }

  onChangeGender(idGenero: any) {
    const generoSelecionado = this._listaGeneros.find(p => p.value === idGenero)?.description;
    if (generoSelecionado) {
      this.isOtherGender = this.outrosValores.includes(generoSelecionado.toLowerCase());
    } else {
      this.formBeneficiario.controls['otherGender'].setValue('');
    }
  }

  preencherDadosDependente(): boolean {
    this.listaDependentes = [];
    this.listaDependentes = this._dependenteComponentViewChild?.listaDependentes?.map(dependente => ({
      id: dependente.id || null,
      holderProposalId: this.titularDaProposta,
      civilStatusId: dependente.civilStatusId,
      name: dependente.name || ' ',
      birthDate: dependente.birthDate || new Date().toISOString(),
      cpf: dependente.cpf,
      sex: dependente.sex || 1,
      mothersName: dependente.mothersName,
      cns: dependente.cns,
      branchCompanyContractKinshipId: dependente.branchCompanyContractKinshipId,
      priceValue: dependente.priceValue || 0,
      proposalType: dependente.proposalType,
    }));
    this.listaDependentes = this._dependenteComponentViewChild?.listaDependentes || [];

    // Verifica se não existem dependentes
    if (!this.ehColaborador) {
      if (!this.listaDependentes || this.listaDependentes.length === 0) {
        this.toastr.warning('Informe o(s) dependente(s).');
        this.pararSpinner();
        return false;
      }

      // Existem dependentes, valida os dados
      if (!this.validarInfoDependente(this.listaDependentes)) {
        this.toastr.warning('Por favor, verificar os campos obrigatórios Dados dos Dependentes.');
        this.pararSpinner();
        return false;
      }
    }
    return true;
  }

  preencherDadosTitular(jsonData: any) {
    this.formBeneficiario.reset();
    this.marcarCamposComoTouched(this.formBeneficiario);
    this.inserirValidadoresAntigaOperadora(jsonData.holderProposal?.analysisPeriodReductionCheck);

    if (jsonData.holderProposal?.analysisPeriodReductionCheck) {
      this.ehReducaoCarencia = true;
    } else {
      this.ehReducaoCarencia = false;
    }
    this.heOdonto = TipoProduto_E_OperadoraComponent.isOdonto(jsonData?.productType);

    this.titularDaProposta = jsonData.holderProposal?.id;
    this.formBeneficiario.patchValue({
      id: jsonData?.id,
      step: jsonData?.step,
      proposalId: jsonData?.holderProposal?.proposalId,
      name: jsonData?.holderProposal.name,
      birthDate: new Date(jsonData?.holderProposal.birthDate),
      cpf: jsonData?.holderProposal.cpf,
      idProfissao: jsonData?.holderProposal?.professionId,
      professionId: jsonData?.holderProposal?.professionId,
      otherProfession: jsonData?.holderProposal.otherProfession,
      sex: jsonData?.holderProposal.sex,
      gender: jsonData?.holderProposal.gender,
      otherGender: jsonData?.holderProposal.otherGender,
      civilStatusId: jsonData?.holderProposal.civilStatusId,
      mobilePhone: jsonData?.holderProposal.mobilePhone,
      homePhone: jsonData?.holderProposal.homePhone,
      businessPhone: jsonData?.holderProposal.businessPhone,
      email: jsonData?.holderProposal.email,
      mothersName: jsonData?.holderProposal.mothersName,
      cns: jsonData?.holderProposal.cns,
      previousOperator: jsonData?.holderProposal?.analysisPeriodReduction?.previousOperator,
      stateId: jsonData?.holderProposal?.analysisPeriodReduction?.stateId,
      cityId: jsonData?.holderProposal?.analysisPeriodReduction?.cityId,
      analysisPeriodReductionCheck: jsonData?.holderProposal?.analysisPeriodReductionCheck,
      proposalType: jsonData?.holderProposal?.analysisPeriodReduction?.proposalType || jsonData?.proposalType,
      dwellTime: jsonData?.holderProposal?.analysisPeriodReduction?.dwellTime,
      // fileDAPO: jsonData?.holderProposal?.analysisPeriodReduction?.dapo,
      // fileCTP: jsonData?.holderProposal?.analysisPeriodReduction?.ctp,
    });
    // this.formBeneficiario.patchValue({
    //   professionId: jsonData?.holderProposal?.professionId,
    // });
    //Remover additiveSignatures da lista de dependentes
    const dependentesSemAdditiveSignatures =
      jsonData?.holderProposal?.dependentsProposal?.map((dependente: any) => {
        const {additiveSignatures, ...dependenteSemAdditiveSignatures} = dependente;
        return dependenteSemAdditiveSignatures;
      }) || [];

    this._dependenteComponentViewChild.listaDependentes = dependentesSemAdditiveSignatures;
  }

  isFormValidDadosTitular() {
    this.isFormSubmited = true;
    return this.formBeneficiario.valid;
  }

  validarInfoDependente(listaDependentes: any[]): boolean {
    for (const dependente of listaDependentes) {
      if (!dependente.name?.trim() || !dependente.cpf?.trim()) {
        return false;
      }
    }
    return true;
  }

  condicionalDeObrigatoriedadeOperadoraAnterior(): boolean {
    return this.ehReducaoCarencia;
  }

  validarCamposReducaoCarenciaTitular(): boolean {
    const ehReducaoCarencia = this.formBeneficiario.controls['analysisPeriodReductionCheck'].value;
    const estadoReducaoCarencia = this.formBeneficiario.controls['stateId'].value;
    const cidadeReducaoCarencia = this.formBeneficiario.controls['cityId'].value;
    const operadoraAnteriorReducaoCarencia = this.formBeneficiario.controls['previousOperator'].value;
    const tempoPermanenciaReducaoCarencia = this.formBeneficiario.controls['dwellTime'].value;

    const algumCampoPreenchido =
      estadoReducaoCarencia ||
      cidadeReducaoCarencia ||
      operadoraAnteriorReducaoCarencia ||
      tempoPermanenciaReducaoCarencia;

    if (!ehReducaoCarencia && algumCampoPreenchido) {
      return false;
    }

    return true;
  }

  //Endereco
  preencherDadosEndereco(dados: any) {
    this.enderecoComponent.preencherFormComponenteSemTabela(dados);
  }

  //Dados Bancários
  criarFormDadosBancarios() {
    this.formGrupDadosBancarios = this.formBuilder.group({
      bankId: new FormControl(null, [Validators.required, Validators.maxLength(250)]),
      agency: new FormControl(null, [Validators.required, Validators.maxLength(10)]),
      agencyDigit: new FormControl(null, [Validators.maxLength(10)]),
      account: new FormControl(null, [Validators.required, Validators.maxLength(12)]),
      accountDigit: new FormControl(null, [Validators.required, Validators.maxLength(12)]),
      otherBankId: new FormControl(''),
      automaticDebit: new FormControl(''),
    });
  }

  preencherDadosBancarios(dados: any) {
    this.formGrupDadosBancarios.reset();
    this.marcarCamposComoTouched(this.formGrupDadosBancarios);
    this.formGrupDadosBancarios.patchValue(dados);

    const outroBancoId = this.listaBancos?.find((x: any) => x.name?.toLowerCase() == 'outro');

    if (!dados?.bank?.automaticDebit) {
      this.filtrarBancosNaoConveniados(false);
      this.bancoConveniado = false;
      this.formGrupDadosBancarios.patchValue({
        otherBankId: dados.bank.id,
        bankId: outroBancoId.id,
        automaticDebit: dados?.bank?.automaticDebit,
      });
    } else {
      this.bancoConveniado = true;
    }
  }

  changeOutroBanco(dadosBancario: any, template: TemplateRef<any>) {
    const outroBanco = dadosBancario?.name?.toLowerCase();
    if (outroBanco == 'outro') {
      this.filtrarBancosNaoConveniados(false);
      this.formGrupDadosBancarios.get('otherBankId')?.setValidators([Validators.required]);
      this.formGrupDadosBancarios.get('automaticDebit')?.setValue(false);
      this.modalRef = this.modalService.show(template, {class: 'modal-lg'});
    } else {
      this.listaDeBancosConveniados =
        this.listaBancos && this.listaBancos.filter((x: any) => x.automaticDebit == true || x.number == 0);
      this.bancoConveniado = true;
      this.formGrupDadosBancarios.get('automaticDebit')?.setValue(true);
      this.formGrupDadosBancarios.get('otherBankId')?.setValue(null);
      this.formGrupDadosBancarios.get('otherBankId')?.clearValidators();
      this.formGrupDadosBancarios.get('otherBankId')?.updateValueAndValidity();
    }
  }

  fecharModalOutroBanco() {
    this.bancoConveniado = false;
    this.modalService.hide();
  }

  filtrarBancosNaoConveniados(automaticDebit: boolean) {
    //outro Banco
    this.listaDeBancosNaoConveniados =
      this.listaBancos && this.listaBancos.filter((x: any) => x.automaticDebit == automaticDebit && x.number != 0);
  }

  isFormValidDadosBancarios() {
    this.isFormSubmited = true;
    return this.formGrupDadosBancarios.valid;
  }

  // Enviar Operadora
  enviarDadosOperadora() {
    if (!this.permissao.podeCadastrarEditar) {
      this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }
    this.iniciarSpinner();
    this.formTouched = true;
    const formEndereco = this.enderecoComponent?.isFormValid() ?? true;

    if (this.enderecoComponent) {
      this.enderecoComponent.formTouched = true;
      this.enderecoComponent.isFormSubmited = true;
      this.enderecoComponent.showErrorMessage = true;
    }

    if (!this.isFormValidDadosTitular()) {
      this.errorMessageDadosTitular = true;
      this.isFormSubmited = true;
      this.goToTop();
      this.toastr.warning('Por favor, verificar os campos obrigatórios Dados do Titular');
      this.pararSpinner();
      return;
    } else if (!formEndereco) {
      this.goToTop();
      this.toastr.warning('Por favor, verificar os campos obrigatórios Dados de Endereço');
      this.pararSpinner();
      return;
    } else if (!this.ehInclusaoDependente!) {
      if (!this.isFormValidDadosBancarios()) {
        this.mostrarMensagemErroBanco = true;
        this.isFormSubmited = true;
        this.goToTop();
        this.toastr.warning('Por favor, verificar os campos obrigatórios Dados Bancários');
        this.pararSpinner();
        return;
      }
    } else if (!this.validarCamposReducaoCarenciaTitular()) {
      this.goToTop();
      this.toastr.warning(
        'Os dados da operadora anterior não podem ser preenchidos, pois o titular não submeteu a redução de carência.',
      );
      this.formBeneficiario.controls['previousOperator'].reset();
      this.formBeneficiario.controls['dwellTime'].reset();
      this.formBeneficiario.controls['stateId'].reset();
      this.formBeneficiario.controls['cityId'].reset();
      this.pararSpinner();
      return;
    }

    try {
      this.preencherDadosDependente();
      const formularioEndereco = this.extrairCamposNecessariosParaEnvioEndereco();

      const dadosBeneficiariosVM = this.formBeneficiario.value;
      dadosBeneficiariosVM.beneficiaryAdress = formularioEndereco;
      dadosBeneficiariosVM.manualEffectiveDate = this.dataVigenciaPrevistaManual
        ? this.dataVigenciaPrevistaManual
        : null;

      // Adiciona os Dependentes
      if (this.listaDependentes) {
        this.listaDependentes.forEach((dependente: any) => {
          if (dependente.analysisPeriodReduction) {
            delete dependente.analysisPeriodReduction.dependentProposalId;
          }
          delete dependente.birthDate;
          delete dependente.branchCompanyContractKinship;
          delete dependente.branchCompanyContractKinshipId;
          delete dependente.civilStatus;
          delete dependente.createDate;
          delete dependente.dateSumula;
          delete dependente.documentProposals;
          delete dependente.healthQuestionProposal;
          delete dependente.height;
          delete dependente.holderProposal;
          delete dependente.neediness;
          delete dependente.noteSupport;
          delete dependente.obsGs;
          delete dependente.otherPendingIssues;
          delete dependente.updateDate;
          delete dependente.weight;
          delete dependente.priceValue;
          delete dependente.holderProposalId;
          delete dependente.proposalType;
          delete dependente.age;
          delete dependente.active;
          delete dependente.sex;
          delete dependente.active;
        });

        dadosBeneficiariosVM.dependents = this.listaDependentes;
      } else {
        delete dadosBeneficiariosVM.dependents;
      }

      // Adiciona Redução de Carências
      if (this.ehReducaoCarencia) {
        dadosBeneficiariosVM.analysisPeriodReduction = {
          previousOperator: dadosBeneficiariosVM.previousOperator,
          dwellTime: dadosBeneficiariosVM.dwellTime,
          stateId: dadosBeneficiariosVM.stateId,
          cityId: dadosBeneficiariosVM.cityId,
        };
      }

      delete dadosBeneficiariosVM.stateId;
      delete dadosBeneficiariosVM.cityId;
      delete dadosBeneficiariosVM.previousOperator;
      delete dadosBeneficiariosVM.proposalType;
      delete dadosBeneficiariosVM.dwellTime;

      if (this.ehInclusaoDependente!) {
        dadosBeneficiariosVM.bankDetails = null;
      } else {
        dadosBeneficiariosVM.bankDetails = this.formGrupDadosBancarios.value;
        delete dadosBeneficiariosVM.bankDetails.automaticDebit;
      }

      this._propostaCotacaoService.finalizarProposta(this.proposalId, dadosBeneficiariosVM).subscribe({
        next: async (data: any) => {
          this.ehReducaoCarencia = this.formBeneficiario.controls['analysisPeriodReductionCheck'].value;

          this.toastr.success('Enviado dados para operadora com sucesso!');
          this.toastr.toastrConfig.preventDuplicates = true;
          this.mostrarBotaoEnviarOperadora = false;
          const temPortabilidade = this.listaDeBeneficiarios.some(
            tipoDeProposta => tipoDeProposta.proposalType === TipoPropostaEnum.PORTABILIDADE,
          );
          if (temPortabilidade) {
            this.mostrarBotaoPortabilidade = true;
          }
          this.pararSpinner();
        },
        error: (e: any) => {
          this._errorLogging.logError('erro ao enviar dados para operadora', e, {
            contexto: '',
            objeto: dadosBeneficiariosVM,
            proposalId: this.proposalId,
          });
          this.toastr.toastrConfig.preventDuplicates = true;
          var mensagemTratada = e.message.replace('Error:', '');
          if (mensagemTratada.includes('[object Object]')) {
            this.toastr.error('Erro ao tentar cadastrar');
            this.pararSpinner();
            return;
          } else {
            this.toastr.error(mensagemTratada);
            this.pararSpinner();
          }
        },
      });
    } catch (error) {
      this.pararSpinner();
      this.toastr.error('erro ao enviar dados para operadora.');
    }
  }

  //portabilidade
  criarFormularioPortabilidade() {
    this.formPortabilidade = this.formBuilder.group({
      beneficiariosPortabilidade: this.formBuilder.array([]),
    });
  }

  ordenarBeneficiarios(beneficiarios: any[]): any[] {
    if (!beneficiarios || !Array.isArray(beneficiarios)) {
      return [];
    }

    return beneficiarios.sort((a, b) => {
      // Titular vem primeiro (holderProposalId não é null)
      if (a.holderProposalId && !b.holderProposalId) return -1;
      if (!a.holderProposalId && b.holderProposalId) return 1;
      return 0;
    });
  }

  getBeneficiariosPortabilidadeArray(): FormArray {
    const array = this.formPortabilidade?.get('beneficiariosPortabilidade') as FormArray;
    return array || this.formBuilder.array([]);
  }

  getOpcaoPortabilidade(index: number): string {
    return this.getBeneficiarioGroup(index).get('opcaoPortabilidade')?.value;
  }

  inicializarFormularioPortabilidade() {
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

    while (beneficiariosArray.length !== 0) {
      beneficiariosArray.removeAt(0);
    }

    const beneficiariosOrdenados = this.getListaBeneficiariosAguardandoPortabilidadeOrdenada();

    beneficiariosOrdenados.forEach((beneficiario, index) => {
      const grupoBeneficiario = this.formBuilder.group({
        opcaoPortabilidade: ['', Validators.required],
        carteirinha: ['', Validators.maxLength(250)],
        vigencia: ['', Validators.maxLength(250)],
        motivosRecusa: this.formBuilder.array([]),
      });

      this.inicializarMotivosRecusa(grupoBeneficiario);

      beneficiariosArray.push(grupoBeneficiario);
    });
  }

  abrirModalPortabilidadeAutomaticamente() {
    if (!this.permissao.podeCadastrarEditar) {
      this.toastr.warning('Você não tem permissão para essa ação. Solicite essa permissão para seu supervisor.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    }
    setTimeout(() => {
      if (this.proposalId && this.modalPortabilidadeTemplate) {
        this.isFormSubmited = false;

        this.buscarBeneficiariosAguardandoPortabilidade(this.proposalId);
        this.abrirModalPortabilidade(this.modalPortabilidadeTemplate);
      } else {
        setTimeout(() => {
          if (this.proposalId && this.modalPortabilidadeTemplate) {
            this.isFormSubmited = false;

            this.buscarBeneficiariosAguardandoPortabilidade(this.proposalId);
            this.abrirModalPortabilidade(this.modalPortabilidadeTemplate);
          }
        }, 2000);
      }
    }, 1000);
  }

  limparCamposAoMudarOpcao(grupo: FormGroup, opcao: string) {
    const carteirinhaControl = grupo.get('carteirinha');
    const vigenciaControl = grupo.get('vigencia');
    const motivosArray = grupo.get('motivosRecusa') as FormArray;

    if (opcao === 'aceitar') {
      if (motivosArray && motivosArray.controls) {
        motivosArray.controls.forEach(control => {
          control.setValue(false);
        });
      }
    } else if (opcao === 'recusar') {
      if (carteirinhaControl) {
        carteirinhaControl.setValue('');
      }
      if (vigenciaControl) {
        vigenciaControl.setValue('');
      }
    }

    if (carteirinhaControl) carteirinhaControl.updateValueAndValidity();
    if (vigenciaControl) vigenciaControl.updateValueAndValidity();
    if (motivosArray) motivosArray.updateValueAndValidity();
  }

  validadorPeloMenosUm(): ValidatorFn {
    return (formArray: AbstractControl): ValidationErrors | null => {
      if (!(formArray instanceof FormArray)) {
        return null;
      }

      const atLeastOneSelected = formArray.controls.some(control => control.value === true);

      return atLeastOneSelected ? null : {required: true};
    };
  }

  marcarTodosCamposPortabilidadeComoTouched() {
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

    beneficiariosArray.controls.forEach((group: AbstractControl, index) => {
      if (group instanceof FormGroup) {
        // Se titular recusou, só marca o titular como touched
        if (this.titularRecusouPortabilidade && index > 0) {
          return; // Pula dependentes
        }

        // Marca o grupo principal
        group.markAllAsTouched();

        // Marca cada controle individualmente
        Object.keys(group.controls).forEach(controlName => {
          const control = group.get(controlName);
          if (control) {
            control.markAsTouched();

            // Se for um FormArray (motivos de recusa), marca cada controle interno
            if (control instanceof FormArray) {
              control.controls.forEach((subControl, subIndex) => {
                subControl.markAsTouched();
              });
            }
          }
        });
      }
    });
  }

  isFormValidDadosPortabilidade(): boolean {
    if (this.titularRecusouPortabilidade) {
      // Só valida o titular quando ele recusou
      const titularGroup = this.getBeneficiarioGroup(0);
      return titularGroup.valid;
    } else {
      // Valida todos quando titular não recusou
      return this.formPortabilidade.valid;
    }
  }

  aplicarValidacoesPorOpcao(grupo: FormGroup, opcao: string, beneficiario: any) {
    const carteirinhaControl = grupo.get('carteirinha');
    const vigenciaControl = grupo.get('vigencia');
    const motivosArray = grupo.get('motivosRecusa') as FormArray;

    carteirinhaControl?.clearValidators();
    vigenciaControl?.clearValidators();
    motivosArray?.clearValidators();

    if (opcao === 'aceitar') {
      carteirinhaControl?.setValidators([Validators.required, Validators.maxLength(250)]);

      if (beneficiario?.holderProposalId) {
        vigenciaControl?.setValidators([Validators.required, Validators.maxLength(250)]);
      } else {
        vigenciaControl?.setValidators([Validators.maxLength(250)]);
      }
    } else if (opcao === 'recusar') {
      // Para RECUSAR: pelo menos um motivo deve ser selecionado
      motivosArray?.setValidators([this.validadorPeloMenosUm()]);

      // Campos de aceite não são obrigatórios
      carteirinhaControl?.setValidators([Validators.maxLength(250)]);
      vigenciaControl?.setValidators([Validators.maxLength(250)]);
    } else {
      // Quando nenhuma opção está selecionada
      carteirinhaControl?.setValidators([Validators.maxLength(250)]);
      vigenciaControl?.setValidators([Validators.maxLength(250)]);
    }

    carteirinhaControl?.updateValueAndValidity();
    vigenciaControl?.updateValueAndValidity();
    motivosArray?.updateValueAndValidity();
  }

  buscarBeneficiariosAguardandoPortabilidade(proposalId: string) {
    try {
      this.iniciarSpinner();
      this._propostaCotacaoService
        .buscarBeneficiariosAguardandoPortabilidade(proposalId)
        .pipe(
          finalize(() => {
            this.pararSpinner();
          }),
        )
        .subscribe(
          data => {
            this.listaBeneficiariosAguardandoPortabilidade = data && data;

            if (this.listaBeneficiariosAguardandoPortabilidade.length > 0) {
              this.inicializarFormularioPortabilidade();
            }
          },
          error => {
            this.pararSpinner();

            if (error.status == 404) {
              this.toastr.warning(error.message);
            } else {
              this.toastr.error('Erro ao carregar beneficiários para portabilidade');
            }
          },
        );
    } catch (error: any) { 
      this.toastr.error('Erro ao processar solicitação de portabilidade');
      this.pararSpinner();
    }
  }

  fecharModalPortabilidade() {
    this.modalPortabilidade = false;
    this.aceiteOuRecusaPortabilidade = undefined;
    this.titularRecusouPortabilidade = false;
    this.formPortabilidade.reset();
    this.isFormSubmited = false;
    this.modalService.hide();
  }

  abrirModalPortabilidade(template: TemplateRef<any>) {
    this.formPortabilidade.reset();
    this.isFormSubmited = false;
    this.titularRecusouPortabilidade = false;

    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg',
      backdrop: false,
      ignoreBackdropClick: true,
    });

    if (this.listaBeneficiariosAguardandoPortabilidade.length > 0) {
      this.inicializarFormularioPortabilidade();

      // Aplica validações iniciais para cada beneficiário
      setTimeout(() => {
        this.getListaBeneficiariosAguardandoPortabilidadeOrdenada().forEach((beneficiario, index) => {
          const opcaoAtual = this.getOpcaoPortabilidade(index);
          if (opcaoAtual) {
            this.aplicarValidacoesPorOpcao(this.getBeneficiarioGroup(index), opcaoAtual, beneficiario);
          }
        });
      });
    }

    this.pararSpinner();
  }

  abrirModalSumulaRecusa() {
    this.modalRefSumulaRecusa = this.modalService.show(this.modalSumulaRecusaTemplate, {
      class: 'modal-lg',
      backdrop: false,
      ignoreBackdropClick: true,
    });

    this.pararSpinner();
  }

  reabilitarDependentes() {
    this.titularRecusouPortabilidade = false;
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();
    // Reabilita os dependentes resetando suas opções
    for (let i = 1; i < beneficiariosArray.length; i++) {
      const dependenteGroup = beneficiariosArray.at(i) as FormGroup;

      dependenteGroup.patchValue({
        opcaoPortabilidade: '',
      });

      // Remove validações
      const dependenteData = this.listaBeneficiariosAguardandoPortabilidadeOrdenada[i];
      this.aplicarValidacoesPorOpcao(dependenteGroup, '', dependenteData);
    }
  }

  getListaBeneficiariosAguardandoPortabilidadeOrdenada(): any[] {
    if (
      !this.listaBeneficiariosAguardandoPortabilidade ||
      !Array.isArray(this.listaBeneficiariosAguardandoPortabilidade) ||
      this.listaBeneficiariosAguardandoPortabilidade.length === 0
    ) {
      return [];
    }

    // Filtrar apenas itens válidos
    const beneficiariosValidos = this.listaBeneficiariosAguardandoPortabilidade.filter(
      item => item && typeof item === 'object',
    );

    return this.ordenarBeneficiarios(beneficiariosValidos);
  }

  getBeneficiarioGroup(index: number): FormGroup {
    try {
      const array = this.getBeneficiariosPortabilidadeArray();
      if (array && array.length > index) {
        const group = array.at(index);
        if (group instanceof FormGroup) {
          return group;
        }
      }

      // Se não encontrou, retorna um grupo vazio para evitar erros
      return this.formBuilder.group({});
    } catch (error) {
      console.error('Erro ao obter grupo do beneficiário:', error);
      return this.formBuilder.group({});
    }
  }

  montarObjetoPortabilidade(): any {
    const dadosBeneficiarios: any[] = [];
    const beneficiariosOrdenados = this.getListaBeneficiariosAguardandoPortabilidadeOrdenada();

    if (this.titularRecusouPortabilidade) {
      const titularData = beneficiariosOrdenados[0];

      if (titularData) {
        const itemTitular: any = {
          holderProposalId: titularData.holderProposalId,
          acceptPortability: false,
          proposalPortabilityRefused: {
            refusedReasons: this.obterMotivosRecusaPortabilidadeSelecionados(0),
          },
        };

        dadosBeneficiarios.push(itemTitular);
      }
    } else {
      const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

      beneficiariosArray.controls.forEach((group: AbstractControl, index) => {
        if (group instanceof FormGroup) {
          const valores = group.value;
          const beneficiario = beneficiariosOrdenados[index];

          // Pular se beneficiário não existe
          if (!beneficiario) return;

          const opcao = valores.opcaoPortabilidade === 'aceitar';

          const item: any = {
            acceptPortability: opcao,
          };

          if (beneficiario.holderProposalId) {
            item.holderProposalId = beneficiario.holderProposalId;
          } else {
            item.dependentId = beneficiario.dependentId;
          }

          if (opcao) {
            item.proposalPortabilityAccept = {
              cardNumberOperator: valores.carteirinha,
            };
            if (beneficiario.holderProposalId) {
              item.proposalPortabilityAccept.effectiveDate = valores.vigencia;
            }
          } else {
            const motivosSelecionados = this.obterMotivosRecusaPortabilidadeSelecionados(index);
            item.proposalPortabilityRefused = {
              refusedReasons: motivosSelecionados,
            };
          }

          dadosBeneficiarios.push(item);
        }
      });
    }
    return dadosBeneficiarios;
  }

  enviarBeneficiariosPortabilidade() {
    this.isFormSubmited = true;
    if (this.getListaBeneficiariosAguardandoPortabilidadeOrdenada().length === 0) {
      this.toastr.warning('Nenhum beneficiário encontrado para portabilidade.');
      return;
    }

    if (this.titularRecusouPortabilidade) {
      // Quando titular recusou, só validar o titular
      const titularGroup = this.getBeneficiarioGroup(0);

      if (!titularGroup) {
        this.toastr.error('Erro: Grupo do titular não encontrado.');
        return;
      }

      titularGroup.markAllAsTouched();

      if (!titularGroup.valid) {
        this.toastr.warning('Preencha todas as informações obrigatórias de portabilidade para o titular.');
        return;
      }
    } else {
      this.marcarTodosCamposPortabilidadeComoTouched();

      if (!this.formPortabilidade.valid) {
        this.toastr.warning('Preencha todas as informações obrigatórias de portabilidade para cada beneficiário.');
        return;
      }
    }


      this.objPortabilidade = this.montarObjetoPortabilidade();

      if (!this.objPortabilidade) {
        this.toastr.error('Erro ao processar dados da portabilidade.');
        return;
      }

      this._propostaCotacaoService
        .enviarBeneficiariosPortabilidade(this.proposalId, this.objPortabilidade)
        .subscribe( {
        next: data => {
      this.fecharModalPortabilidade();
      this.toastr.success('Portabilidade dos beneficiários atualizado com sucesso!');
      this.toastr.toastrConfig.preventDuplicates = true;
      this.mostrarBotaoPortabilidade = false;
    },
        error: (err: any) => {
          const mensagem = err?.error?.message || err?.error || err?.message || 'Erro ao processar portabilidade.';
          this.toastr.error(mensagem);
          this._errorLogging.logError(mensagem, err, {
            contexto: 'proposta-beneficiario-colaborador.enviarBeneficiariosPortabilidade',
            objeto: this.objPortabilidade,
            proposalId: this.proposalId,
          });
        },
      });
  }
  //portabilidade Aceite
  get aceitePortabilidadeArray(): FormArray {
    return this.formPortabilidade.get('aceitePortabilidade') as FormArray;
  }

  private getCampoDataVigenciaCarterinha(campoId: string | number): HTMLInputElement & {datepickerInstance?: any} {
    const id = typeof campoId === 'number' ? `vigencia-${campoId}` : campoId;
    return document.getElementById(id) as HTMLInputElement & {
      datepickerInstance?: any;
    };
  }

  formatarCampoData(valor: string, campoId: string | number): string {
    this.onFieldChange();
    const elementoCampoData = this.getCampoDataVigenciaCarterinha(campoId);
    const valorCampo = valor?.toString() ?? '';
    if (valorCampo == 'Invalid Date' || (valorCampo && isNaN(Date.parse(valorCampo)))) {
      this.menssagemErroCampoData = 'Data inválida';
      setTimeout(() => {
        elementoCampoData.value = 'Data inválida';
        this.menssagemErroCampoData = '';
      }, 0);
      return '';
    }

    const apenasNumeros = valorCampo.replace(/\D/g, '');

    if (apenasNumeros.length <= 2) {
      return apenasNumeros; // Apenas o dia
    } else if (apenasNumeros.length <= 4) {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(2)}`; // Dia/Mês
    } else {
      return `${apenasNumeros.slice(0, 2)}/${apenasNumeros.slice(2, 4)}/${apenasNumeros.slice(4)}`; // Dia/Mês/Ano
    }
  }

  abrirCalendarioVigencia(datepicker: BsDatepickerDirective) {
    if (datepicker.isOpen) {
      datepicker.hide();
    } else {
      datepicker.show();
    }
  }

  getCarteirinhaControl(index: number): AbstractControl {
    return this.getBeneficiarioGroup(index).get('carteirinha') as AbstractControl;
  }

  getVigenciaControl(index: number): AbstractControl {
    return this.getBeneficiarioGroup(index).get('vigencia') as AbstractControl;
  }

  //recusa portabilidade
  buscarOpcoesRecusaPortabilidade() {
    this._motivoRecusaPortabilidadeService.motivosRecusaPortabilidade().subscribe(data => {
      this.opcoesRecusa = data && data;
    });
    this.inicializarFormularioPortabilidade();
  }

  get recusaPortabilidadeArray(): FormArray {
    return this.formPortabilidade.get('recusaPortabilidade') as FormArray;
  }

  ocultarDependentesAposRecusaTitular() {
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

    if (beneficiariosArray.length <= 1) return;

    // Percorre todos os beneficiários a partir do índice 1 (dependentes)
    for (let i = 1; i < beneficiariosArray.length; i++) {
      const dependenteGroup = beneficiariosArray.at(i) as FormGroup;

      // Define a opção como 'recusar' e desabilita o grupo
      dependenteGroup.patchValue({
        opcaoPortabilidade: 'recusar',
      });

      // Desabilita todos os controles do dependente
      Object.keys(dependenteGroup.controls).forEach(controlName => {
        const control = dependenteGroup.get(controlName);
        if (control) {
          control.disable();
        }
      });
    }

    this.toastr.info('Os dependentes foram automaticamente recusados devido à recusa do titular.');
  }

  getMotivosRecusaArray(index: number): FormArray {
    return this.getBeneficiarioGroup(index).get('motivosRecusa') as FormArray;
  }

  obterMotivosRecusaPortabilidadeSelecionados(index: number): string[] {
    const motivosSelecionados: string[] = [];
    const motivosArray = this.getMotivosRecusaArray(index);

    motivosArray.controls.forEach((control, motivoIndex) => {
      if (control.value === true) {
        // Usa o valor do motivo (não o índice)
        const motivoValue = this.opcoesRecusa[motivoIndex]?.value;
        if (motivoValue) {
          motivosSelecionados.push(motivoValue);
        }
      }
    });

    return motivosSelecionados;
  }

  inicializarMotivosRecusa(grupoBeneficiario: FormGroup) {
    const motivosArray = grupoBeneficiario.get('motivosRecusa') as FormArray;

    while (motivosArray.length !== 0) {
      motivosArray.removeAt(0);
    }

    // Adiciona controles para cada opção de recusa
    this.opcoesRecusa.forEach(() => {
      motivosArray.push(new FormControl(false));
    });
  }

  recusarDependentesAutomaticamente() {
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

    if (beneficiariosArray.length <= 1) return;

    // Define todos os dependentes como recusados
    for (let i = 1; i < beneficiariosArray.length; i++) {
      const dependenteGroup = beneficiariosArray.at(i) as FormGroup;

      dependenteGroup.patchValue({
        opcaoPortabilidade: 'recusar',
      });

      // Aplica as validações de recusa
      const dependenteData = this.listaBeneficiariosAguardandoPortabilidadeOrdenada[i];
      this.aplicarValidacoesPorOpcao(dependenteGroup, 'recusar', dependenteData);
    }
  }

  verificarRecusaTitular() {
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

    if (beneficiariosArray.length === 0) return;

    // Verifica se o titular (primeiro beneficiário) recusou
    const titularGroup = beneficiariosArray.at(0) as FormGroup;
    const opcaoTitular = titularGroup.get('opcaoPortabilidade')?.value;

    this.titularRecusouPortabilidade = opcaoTitular === 'recusar';

    if (this.titularRecusouPortabilidade) {
      this.recusarDependentesAutomaticamente();

      // Garante que os dependentes sejam considerados válidos
      this.validarDependentesAposRecusaTitular();
    }
  }

  validarDependentesAposRecusaTitular() {
    const beneficiariosArray = this.getBeneficiariosPortabilidadeArray();

    // Para cada dependente, garante que esteja válido
    for (let i = 1; i < beneficiariosArray.length; i++) {
      const dependenteGroup = beneficiariosArray.at(i) as FormGroup;

      // Limpa validadores dos campos de aceite
      const carteirinhaControl = dependenteGroup.get('carteirinha');
      const vigenciaControl = dependenteGroup.get('vigencia');

      carteirinhaControl?.clearValidators();
      vigenciaControl?.clearValidators();

      carteirinhaControl?.updateValueAndValidity();
      vigenciaControl?.updateValueAndValidity();

      // Aplica validadores mínimos para recusa
      const motivosArray = dependenteGroup.get('motivosRecusa') as FormArray;
      motivosArray?.clearValidators();
      motivosArray?.updateValueAndValidity();
    }
  }

  onOpcaoPortabilidadeChange(index: number, opcao: string) {
    const beneficiarioGroup = this.getBeneficiarioGroup(index);
    const beneficiarioData = this.listaBeneficiariosAguardandoPortabilidadeOrdenada[index];

    this.limparCamposAoMudarOpcao(beneficiarioGroup, opcao);
    this.aplicarValidacoesPorOpcao(beneficiarioGroup, opcao, beneficiarioData);

    // Se for o titular (index 0) e recusou, recusa dependentes automaticamente
    if (index === 0 && opcao === 'recusar') {
      this.verificarRecusaTitular();
    }

    // Se for o titular e aceitou, reabilita os dependentes
    if (index === 0 && opcao === 'aceitar') {
      this.reabilitarDependentes();
    }

    // Força atualização da validação do formulário
    this.formPortabilidade.updateValueAndValidity();
  }

  erroSentry(tituloErro: any, erro: any, mensagemErro: any, data: any) {
    this._errorLogging.logError(mensagemErro, data, {
      contexto: tituloErro,
      data: data,
    });
  }

  dexarFormSomenteLeitura(somenteLeituraStep: boolean = false) {
    if (somenteLeituraStep) {
      this.formBeneficiario.disable({emitEvent: false});
      this.enderecoComponent?.enderecoForm.disable();
      this.formGrupDadosBancarios.disable({emitEvent: false});
      this._dependenteComponentViewChild &&
        this._dependenteComponentViewChild.formularioDependente.disable({emitEvent: false});
    } else {
      this.formBeneficiario.enable({emitEvent: false});
      this.enderecoComponent?.enderecoForm.enable();
      this.formGrupDadosBancarios.enable({emitEvent: false});
      this._dependenteComponentViewChild &&
        this._dependenteComponentViewChild.formularioDependente.enable({emitEvent: false});
    }
  }

  permissao = {
    podeCadastrarEditar: this.moduloPermissoesService.permissaoCadastrarEditar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_CADASTRO,
    ),
  };

  permissaoCorretorExterno = {
    podeCadastrarEditar: this.moduloPermissoesService.permissaoCadastrarEditar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_SOMENTE_NOVA_ADESAO,
    ),
    podeVisualizar: this.moduloPermissoesService.permissaoVisualizar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_SOMENTE_NOVA_ADESAO,
    ),
    podeInativar: this.moduloPermissoesService.permissaoInativar(
      Modulo.CADASTROS,
      SubModuloNome.PROPOSTA_SOMENTE_NOVA_ADESAO,
    ),
  };

  receberDeclinio(stepDeclinado: number) {
    this.stepAtual = stepDeclinado || this.propostaEnum.PROPOSTA_DECLINADA;
    this.mostrarBotaoPortabilidade = false;
    this.mostrarBotaoEnviarOperadora = false;
  }

  async cadastrarEndereco(ehColaborador: boolean): Promise<void> {
    ehColaborador = true;
    const formularioEndereco = this.extrairCamposNecessariosParaEnvioEndereco();

    const dadosEndereco = {
      holderProposalId: this.titularDaProposta,
      proposalId: this.proposalId,
      ...formularioEndereco,
    };

    this._propostaCotacaoService.cadastrarEndereco(dadosEndereco, ehColaborador).subscribe({
      next: async retorno => {
        this.pararSpinner();

        this.toastr.success('Endereço cadastrado');
      },
      error: (e: any) => {
        this.toastr.toastrConfig.preventDuplicates = true;

        var mensagemTratada = e.message.replace('Error:', '');
        if (mensagemTratada.includes('[object Object]')) {
          this.toastr.error('Erro ao tentar cadastrar o endereço');
          this.pararSpinner();
          return;
        } else {
          this.toastr.error('Erro ao tentar cadastrar endereço ');
          this.pararSpinner();
        }
      },
    });
  }

  async cadastrarDadosBancario(ehColaborador: boolean) {
    ehColaborador = true;
    const dadosBancarioVM = this.formGrupDadosBancarios.value;
    this.iniciarSpinner();
    const idBanco = dadosBancarioVM?.bankId;
    dadosBancarioVM.holderProposalId = this.dadosRecebidosDoBeneciarioVM?.holderProposalId || this.titularDaProposta;
    dadosBancarioVM.proposalId = this.dadosRecebidosDoBeneciarioVM?.proposalId || this.proposalId;
    dadosBancarioVM.bankId = null;

    if (!dadosBancarioVM?.automaticDebit) {
      //outro banco
      dadosBancarioVM.bankId = idBanco || dadosBancarioVM.otherBankId;
    } else {
      dadosBancarioVM.bankId = idBanco || idBanco.bankId?.id;
      delete dadosBancarioVM.otherBankId;
    }

    this._beneficiarioProposaService
      .cadastrarDadosBancario(dadosBancarioVM, ehColaborador)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: async retorno => {
          this.toastr.success('Dados  Bancário cadastrado!');
        },
        error: (e: any) => {
          this.toastr.toastrConfig.preventDuplicates = true;
          this._errorLogging.logError('Falha ao buscar dados Bancário cadastrado!', e, {
            contexto: 'Falha ao buscar dados Bancário cadastrado!',
            data: dadosBancarioVM,
          });
          var mensagemTratada = e.message.replace('Error:', '');

          if (mensagemTratada.includes('[object Object]')) {
            this.pararSpinner();
            return;
          } else {
            this.toastr.error(e.message);
            this.pararSpinner();
          }
        },
      });
  }

  onSalvarDadosBeneficiario() {
    this.formTouched = true;
    this.toastr.toastrConfig.preventDuplicates = true;
    const formEndereco = this.enderecoComponent?.isFormValid() ?? true;

    if (this.enderecoComponent) {
      this.enderecoComponent.formTouched = true;
      this.enderecoComponent.isFormSubmited = true;
      this.enderecoComponent.showErrorMessage = true;
    }

    if (!this.formBeneficiario.valid) {
      this.errorMessageDadosTitular = true;
      this.toastr.warning('Por favor, verificar todos os campos obrigatórios');

      return;
    } else this.errorMessageDadosTitular = false;

    //validar o enderecoForm
    if (!formEndereco) {
      this.toastr.warning('Por favor, preencher os dados de endereço.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return;
    } else if (!this.ehInclusaoDependente) {
      //validar o dados Bancarios
      if (!this.formGrupDadosBancarios.valid) {
        this.mostrarMensagemErroBanco = true;
        this.toastr.warning('Por favor, preencher os dados bancários.');
        return;
      } else this.mostrarMensagemErroBanco = false;
    }

    if (!this.preencherDadosDependente()) {
      return;
    }

    this.iniciarSpinner();
    // Limpa campos de análise se a opção estiver desmarcada
    if (!this.formBeneficiario.value.analysisPeriodReductionCheck) {
      this.formBeneficiario.patchValue({
        previousOperator: null,
        dwellTime: null,
        stateId: null,
        cityId: null,
      });
    }

    const dadosBeneficiariosVM = this.formBeneficiario.value;

    // Garante que os IDs estão corretos
    dadosBeneficiariosVM.id = this.titularDaProposta;
    dadosBeneficiariosVM.proposalId = this.proposalId;
    dadosBeneficiariosVM.professionId = dadosBeneficiariosVM.idProfissao;
    // dadosBeneficiariosVM.isAssociate = this.jaAssociou_se;
    const holderProposal: any = {
      ...dadosBeneficiariosVM,
      analysisPeriodReductionCheck: this.formBeneficiario.value.analysisPeriodReductionCheck,
    };

    // Adiciona analysisPeriodReduction apenas se analysisPeriodReductionCheck for true
    if (this.formBeneficiario.value.analysisPeriodReductionCheck) {
      holderProposal.analysisPeriodReduction = {
        holderProposalId: this.titularDaProposta,
        previousOperator: dadosBeneficiariosVM?.previousOperator,
        proposalType: dadosBeneficiariosVM?.proposalType,
        dwellTime: dadosBeneficiariosVM?.dwellTime,
        stateId: dadosBeneficiariosVM?.stateId,
        cityId: dadosBeneficiariosVM?.cityId,
      };
    }

    const formularioEndereco = this.extrairCamposNecessariosParaEnvioEndereco();

    holderProposal.addressData = formularioEndereco;
    const dadosPropostaVM = {
      proposal: {
        id: this.proposalId,
        preLeadId: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario?.preleadId,
        dependentInclusion: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario?.dependentInclusion,
      },
      holderProposal: holderProposal,
      dependents: this.listaDependentes,
    };

    // Remove campos desnecessários do holderProposal
    delete dadosPropostaVM?.holderProposal.stateId;
    delete dadosPropostaVM?.holderProposal.cityId;
    delete dadosPropostaVM?.holderProposal.previousOperator;
    delete dadosPropostaVM?.holderProposal.proposalType;
    delete dadosPropostaVM?.holderProposal.dwellTime;

    this._propostaCotacaoService
      .cadastrar(dadosPropostaVM, this.isBeneficiary)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: async (data: any) => {
          // Preenche dados de endereço
          await this.execucaoSegura
            .executar(() => this.cadastrarEndereco(this.ehColaborador))
            .catch(error =>
              this.erroSentry('Erro ao cadastrar endereço', error, 'Falha ao cadastrar dados de endereço', data),
            );

          if (!this.ehInclusaoDependente) {
            await this.execucaoSegura
              .executar(() => this.cadastrarDadosBancario(this.ehColaborador))
              .catch(error =>
                this.erroSentry(
                  'Erro ao preencher os dados bancários',
                  error,
                  'Falha ao processar os dados bancários do titular',
                  data,
                ),
              );
          }
          this.toastr.success('Dados do beneficiário atulizado com sucesso!');
          this.toastr.toastrConfig.preventDuplicates = true;
        },
        error: (e: any) => {
          this.pararSpinner();
          this.toastr.toastrConfig.preventDuplicates = true;
          var mensagemTratada = e.message.replace('Error:', '');
          if (mensagemTratada.includes('[object Object]')) {
            this.toastr.error('Erro ao tentar cadastrar');
            return;
          } else {
            this.toastr.error(mensagemTratada);
          }
        },
      });
  }

  criarFormularioProposta() {
    this.formProposta = this.formBuilder.group({
      manualEffectiveDate: new FormControl(null),
    });
  }

  abrirModaVigenciaPrevista(template: TemplateRef<any>) {
    if (this.mostrarModalVigenciaPrevista) {
      if (!this.dataVigenciaPrevistaManual && this.modalVigenciaPrevistaTemplate) {
        this.escolherTextoModalVigenciaManual();
        this.modalRef = this.modalService.show(template, {
          class: 'modal-md',
          backdrop: false,
          ignoreBackdropClick: true,
        });
      }
    } else {
      this.enviarDadosOperadora();
    }
  }

  fecharModalVigenciaPrevista() {
    this.modalService.hide();
  }

  adicionarVigencia() {
    if (!this.formProposta.controls['manualEffectiveDate'].value) {
      this.toastr.warning('Por favor preencha o campo vigência prevista antes de continuar.');
      return;
    } else {
      this.dataVigenciaPrevistaManual = new Date(this.formProposta.controls['manualEffectiveDate'].value).toISOString();
      this.mostrarModalVigenciaPrevista = false;
      this.fecharModalVigenciaPrevista();
      this.enviarDadosOperadora();
    }
  }

  escolherTextoModalVigenciaManual() {
    let ehPortabilidade = this.listaDeBeneficiarios.some(
      tipoProposta => tipoProposta.proposalType === TipoPropostaEnum.PORTABILIDADE,
    );
    let ehIDRecemCasado = this.listaDeBeneficiarios.some(
      tipoProposta => tipoProposta.proposalType === TipoPropostaEnum.RECEM_CASADO,
    );

    if (
      ehPortabilidade ||
      (this.ehInclusaoDependente && ehIDRecemCasado) ||
      (this.ehInclusaoDependente && ehPortabilidade)
    ) {
      this.textoModalVigenciaManual = `Necessário adicionar vigência, pois essa proposta contém ${TipoPropostaEnumDescription.getDescricao(TipoPropostaEnum.PORTABILIDADE)}`;
    } else if (this.ehInclusaoDependente && ehIDRecemCasado) {
      this.textoModalVigenciaManual = `Necessário adicionar vigência, pois essa proposta é inclusão de dependente e contém ${TipoPropostaEnumDescription.getDescricao(TipoPropostaEnum.RECEM_CASADO)}`;
    } else if (this.ehInclusaoDependente && ehPortabilidade) {
      this.textoModalVigenciaManual = `Necessário adicionar vigência, pois essa proposta é inclusão de dependente e contém ${TipoPropostaEnumDescription.getDescricao(TipoPropostaEnum.PORTABILIDADE)}`;
    }
  }

  // modal sumula 21
  separarBeneficiarioSumula21(): any {
    // Filtra apenas os que têm proposalType = SÚMULA (3)
    const beneficiariosSumula = this.listaDeBeneficiarios.filter(item => item.proposalType === TipoPropostaEnum.SUMULA);
    const resultado: any = {};

    beneficiariosSumula?.forEach(item => {
      // Se for titular
      if (item.proposalId) {
        const proposalId = item.name + '-' + item.id;
        resultado[proposalId] = {
          proposalId: item.proposalId,
          id: item.id,
          name: item.name,
          proposalType: item.proposalType,
          titular: {...item},
          dependentes: [],
        };
      }
    });

    // Adiciona os dependentes
    beneficiariosSumula.forEach(item => {
      if (item.holderProposalId) {
        for (let key in resultado) {
          if (resultado[key].titular.id === item.holderProposalId) {
            resultado[key].dependentes.push({
              id: item.id,
              name: item.name,
              proposalId: item.proposalId,
            });
            break;
          }
        }
      }
    });

    return (this.listabeneficiariosComSumula21 = resultado);
  }

  checkboxSelecionarTodos = false;
  beneficiarioComSumulasSelecionados: string[] = [];
  @ViewChild('modalConfirmacao') modalConfirmacao: any;
  getBeneficiariosSelecionados() {
    const selecionados = [];

    for (let grupo of Object.values(this.listabeneficiariosComSumula21)) {
      // Verifica titular
      if (this.beneficiarioComSumulasSelecionados.includes(grupo.titular.id)) {
        selecionados.push({
          id: grupo.titular.id,
          nome: grupo.titular.name,
          cpf: grupo.titular.cpf,
          tipo: 'Titular',
          proposalId: grupo.titular.proposalId,
          dadosCompletos: grupo.titular,
        });
      }

      // Verifica dependentes
      for (let dependente of grupo.dependentes) {
        if (this.beneficiarioComSumulasSelecionados.includes(dependente.id)) {
          selecionados.push({
            id: dependente.id,
            nome: dependente.name,
            cpf: dependente.cpf,
            tipo: 'Dependente',
            holderProposalId: dependente.holderProposalId,
            dadosCompletos: dependente,
          });
        }
      }
    }

    return selecionados;
  }

  abrirModalConfirmacao() {
    if (this.beneficiarioComSumulasSelecionados.length === 0) {
      this.toastr.warning('Selecione pelo menos um beneficiário');
      return;
    }

    // Fecha o modal anterior se estiver aberto
    if (this.modalRefSumulaRecusa) {
      this.modalRefSumulaRecusa.hide();
    }
    this.modalRefConfirmacao = this.modalService.show(this.modalConfirmacao, {
      class: 'modal-lg',
      backdrop: false,
      ignoreBackdropClick: true,
    });
  }

  confirmarEnvio() {
    const selecionados = this.getBeneficiariosSelecionados();
    this.iniciarSpinner();
    // Fecha o modal
    if (this.modalRefConfirmacao) {
      this.modalRefConfirmacao.hide();
    }
    this._propostaCotacaoService
      .enviarRetornoOperadorSumula21(this.proposalId, this.beneficiarioComSumulasSelecionados)
      .subscribe({
        next: async (data: any) => {
          (this, this.fecharModalSumula21());
          this.toastr.success(` E-mail enviado com sucesso!`);
          this.beneficiarioComSumulasSelecionados = [];
          this.checkboxSelecionarTodos = false;
          this.pararSpinner();
        },
        error: (e: any) => {
          this._errorLogging.logError('erro ao enviar dados para operadora sumula 21', e, {
            contexto: '',
            objeto: this.listabeneficiariosComSumula21,
            proposalId: this.proposalId,
          });
          this.toastr.toastrConfig.preventDuplicates = true;
          var mensagemTratada = e.message.replace('Error:', '');
          if (mensagemTratada.includes('[object Object]')) {
            this.toastr.error('erro ao enviar dados para operadora sumula 21');
            this.pararSpinner();
            return;
          } else {
            this.toastr.error(mensagemTratada);
            this.pararSpinner();
          }
        },
      });
  }

  fecharModalSumula21() {
    this.modalRefSumulaRecusa?.hide();
  }

  fecharModalSumula21Confirmar() {
    if (this.modalRefConfirmacao) {
      this.modalRefConfirmacao.hide();
    }

    // Reabre o modal principal
    this.modalRefSumulaRecusa = this.modalService.show(this.modalSumulaRecusaTemplate, {
      class: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: false,
    });
  }

  // Verifica se está selecionado
  isSelecionado(id: string) {
    return this.beneficiarioComSumulasSelecionados.includes(id);
  }

  // Marca/desmarca um item
  toggleSelecionado(id: string, event: any) {
    if (event.target.checked) {
      this.beneficiarioComSumulasSelecionados.push(id);
    } else {
      this.beneficiarioComSumulasSelecionados = this.beneficiarioComSumulasSelecionados.filter(i => i !== id);
    }

    // Atualiza "selecionar todos"
    const total = Object.values(this.listabeneficiariosComSumula21).reduce((t, g) => t + 1 + g.dependentes.length, 0);
    this.checkboxSelecionarTodos = this.beneficiarioComSumulasSelecionados.length === total;
  }

  // Marca/desmarca todos
  selecionarTodos(event: any) {
    // Se marcou o checkbox "Selecionar Todos"
    if (event.target.checked) {
      for (let grupo of Object.values(this.listabeneficiariosComSumula21)) {
        // Adiciona o titular
        this.beneficiarioComSumulasSelecionados.push(grupo.titular.id);

        // Adiciona cada dependente
        for (let dependente of grupo.dependentes) {
          this.beneficiarioComSumulasSelecionados.push(dependente.id);
        }
      }
    } else {
      // Se desmarcou, limpa a lista
      this.beneficiarioComSumulasSelecionados = [];
    }

    // Atualiza o estado do checkbox "Selecionar Todos"
    this.checkboxSelecionarTodos = event.target.checked;
  }

  get usuarioNaoEhCorretorExterno(): boolean {
    return (
      !this.permissaoCorretorExterno?.podeCadastrarEditar &&
      !this.permissaoCorretorExterno?.podeInativar &&
      !this.permissaoCorretorExterno?.podeVisualizar
    );
  }

  get podeExibirBotaoEnviarOperadora(): boolean {
    return this.mostrarBotaoEnviarOperadora && this.permissao?.podeCadastrarEditar && this.usuarioNaoEhCorretorExterno;
  }

  get podeExibirBotaoEnviarPortabilidade(): boolean {
    return this.mostrarBotaoPortabilidade && this.permissao?.podeCadastrarEditar && this.usuarioNaoEhCorretorExterno;
  }

  extrairCamposNecessariosParaEnvioEndereco() {
    const formularioEndereco = this.enderecoComponent?.enderecoForm.value;
    delete formularioEndereco['id'];
    delete formularioEndereco['active'];
    delete formularioEndereco['cityName'];
    delete formularioEndereco['stateName'];
    delete formularioEndereco['internationalCity'];
    delete formularioEndereco['internationalState'];
    delete formularioEndereco['internationalHome'];
    return formularioEndereco;
  }
}
